import { Component, OnInit ,OnDestroy } from '@angular/core';
import { AuthService } from '../../../services/auth.service';
import { environment } from 'src/environments/environment';
declare const zE: any;


@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  public link: string = '';
  public showFilter: boolean = true;

  constructor(private authService: AuthService) { }

  ngOnInit(): void {
    if (environment.zendChatLink != "") {
      this.addChat()
      for (var id = 0;  id < document.getElementsByTagName('iframe').length; id++) {
        if (document.getElementsByTagName('iframe')[id].title == 'Button to launch messaging window') {
          if (document.getElementsByTagName('iframe')[id] != null) {
            document.getElementsByTagName('iframe')[id].style.visibility = 'visible';
          }
        }
      }
    }
   // this.authService.producerOnlyLogout();
  }

  ngOnDestroy(): void {
   // zE(function() {zE.hide();});
    //document.getElementsByTagName('iframe')[3].style.visibility = 'hidden';
    for (var id = 0;  id < document.getElementsByTagName('iframe').length; id++) {
        if (document.getElementsByTagName('iframe')[id].title == 'Button to launch messaging window') {
          if (document.getElementsByTagName('iframe')[id] != null) {
            document.getElementsByTagName('iframe')[id].style.visibility = 'hidden';
        }
      }
    }
  }


  addChat() {
    let dynamicScript = document.createElement("script");
    dynamicScript.setAttribute('id', 'ze-snippet')
    dynamicScript.setAttribute('src', environment.zendChatLink)
    document.head.appendChild(dynamicScript);
  }



}
